import React from 'react';
import {Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import {useStore} from "@/app/providers/StoreProvider";
import {ModalPayload} from "@/entities/modals/types";


export const QuestCompletedModal = (payload: ModalPayload<"questCompleted">) => {
    const { modalStore } = useStore();

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.closeAll()} alt=""/>}
        >
            <div className='modal'>

                <h3 className='modal_title'>Поздравляем!</h3>
                <p className='modal_text'>Задание выполнено</p>


                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.closeAll()}>Закрыть
                    </button>
                </div>

            </div>
        </Modal>
    );
};

